import InvoiceTable from './InvoiceTable.component';

export default InvoiceTable;
